export function parseStartApp(startapp?: string): string | null {
    if (!startapp) return null;

    const [type, value] = startapp.split("_");

    switch (type) {
        case "e": // event
            return value ? `/events/${value}` : "/events";
        case "p": // profile
            return value ? `/profiles/${value}` : "/profiles";
        case "my":
            return "/my";
        case "scout":
            return "/events";
        default:
            return "/home";
    }
}

export function parseScoutCode(startapp?: string): string | null {
    if (!startapp) return null;

    const [type, ...rest] = startapp.split("_");
    if (type !== "scout" || !rest.length) return null;

    const code = rest.join("_").trim();

    return code || null;
}
